/**
 * 全局 Toast 提示
 * 统一管理 toast 状态，避免各页面重复实现
 */

import { ref } from 'vue'

const visible = ref(false)
const message = ref('')
let timer: ReturnType<typeof setTimeout> | null = null

/**
 * 显示 toast 提示
 * @param msg 提示信息
 * @param duration 显示时长（毫秒），默认 2000
 */
export function showToast(msg: string, duration = 2000) {
  if (timer) clearTimeout(timer)
  message.value = msg
  visible.value = true
  timer = setTimeout(() => {
    visible.value = false
  }, duration)
}

/**
 * 隐藏 toast
 */
export function hideToast() {
  if (timer) clearTimeout(timer)
  visible.value = false
}

/**
 * Toast composable
 */
export function useToast() {
  return {
    visible,
    message,
    showToast,
    hideToast,
  }
}
